<template>
  <div id="scrollBody">
    <div
      style="padding: 10px;font-size: 16px;border-bottom: 2px solid #eee;"
      class="clearfix"
      v-cloak
    >
      <span class="fl">{{studentInfo.FullName}}</span>
      <span class="fl">{{studentInfo.UserName}}</span>
      <span class="fr">
        学分：
        <b>{{ studentInfo.DimensionShow && studentInfo.DimensionShow.count }}</b>
      </span>
    </div>
    <ul class="scrollList">
      <li v-for="item in pageList" :key="item.id">
        <div class="box-body clearfix" v-cloak>
          <div class="fl">{{item.title}}</div>
          <div class="fr">得分:{{item.StudentScore}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ScoreDetails",
  data() {
    return {
      rowData: {},
      page: 1,
      pageSize: 15,
      pageList: [],
      studentInfo: {}
    };
  },
  created() {
    this.rowData = this.$store.state.evaluation.studentId;
    this.loadList();
  },
  methods: {
    async loadList() {
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/ProjectStudentScore/GetUserScore",
        // {
        //   id: this.rowData.StudentID
        // }
      );
      if (res.success) {
        this.studentInfo = res.data;
        //处理返回数据
        this.findLastList(this.studentInfo.DimensionShow.DimensionShow);
      }
    },
    findLastList(obj) {
      var arr = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        if (obj[i].children !== null && obj[i].children.length > 0) {
          (function() {
            var _obj = arguments[0];
            for (var j = 0, _len = _obj.length; j < _len; j++) {
              if (_obj[j].children !== null && _obj[j].children.length > 0) {
                arguments.callee(_obj[j].children); //递归匿名方法
              } else {
                arr.push({
                  title: _obj[j].title,
                  StudentScore: _obj[j].StudentScore
                });
              }
            }
          })(obj[i].children);
        } else {
          arr.push({ title: obj[i].title, StudentScore: obj[i].StudentScore });
        }
      }
      this.pageList = arr;
    }
  }
};
</script>

<style lang="less" scoped>
</style>
